module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "isModal": false,
      "title": 'EXAMES' + (_vm.funcionario ? ' - ' + _vm.funcionario.nome : '') + (_vm.formData.consulta ? ' - CONSULTA ' + _vm.formData.consulta.id_con : ''),
      "width": "60%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-table', {
    attrs: {
      "tableData": _vm.tableDataExame,
      "tableHead": _vm.tableHeadExame,
      "pagination": _vm.paginationExame,
      "response": _vm.response,
      "loadingTable": _vm.loadingTableExame,
      "onSearch": _vm.getExame,
      "disableCheckAll": "",
      "disableInputSearch": "",
      "disabledConfigCell": ""
    }
  })], 1)]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "description": "Exibindo o histórico de consultas dos últimos 10 anos",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableCheckAll": "",
      "disableInputSearch": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c76ba2b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/empresa/consulta/_includes/historico.vue
// module id = 1407
// module chunks = 45